<template>
  <div v-if="attachmentInfo && attachmentInfo.type=='ask-for-donation'" class="preview-img">

    <figure>
      <span v-on:click.prevent="$emit('remove-attachment')" class="remove"></span>
      <img :src="require('./icons/make-a-donation.png')" alt="Make a Donation">
      <figcaption class="img-caption">
        <p>Make a Donation</p>
        <a target="_blank" :href="attachmentInfo.link">{{shortLink}}</a>
      </figcaption>
    </figure>

  </div>

  <div v-else-if="attachmentInfo && attachmentInfo.type=='send-webapp-link'" class="preview-img">
    <figure v-if="charityInfo">
      <span v-on:click.prevent="$emit('remove-attachment')" class="remove"></span>
      <div class="charity-logo">
        <img v-if="charityInfo.logo_transparent" :src="charityInfo.logo_transparent" :alt="charityInfo.charity_name">
      </div>
      <figcaption class="img-caption">
        <p>{{title}}</p>
        <a target="_blank" :href="attachmentInfo.link">{{shortLink}}</a>
      </figcaption>
    </figure>
  </div>

  <div v-else-if="attachmentInfo && attachmentInfo.type=='add-photo'" class="preview-img">
    <figure class="type-media">
      <span v-on:click.prevent="$emit('remove-attachment')" class="remove"></span>
      <img :src="attachmentInfo.link" alt="">
    </figure>
  </div>

  <div v-else-if="attachmentInfo && attachmentInfo.type=='add-video'" class="preview-img">
    <figure v-if="videoThumbnail" class="type-media">
      <span v-on:click.prevent="$emit('remove-attachment')" class="remove"></span>
      <img :src="videoThumbnail" alt="">
    </figure>
  </div>

  <div v-else-if="attachmentInfo && attachmentInfo.type=='attach-post'" class="preview-img">
    <figure v-if="postInfo">
      <span v-on:click.prevent="$emit('remove-attachment')" class="remove"></span>
      <img v-if="postImage" :src="postImage" :alt="postInfo.title">
      <figcaption class="img-caption">
        <p>{{postInfo.title}}</p>
        <a target="_blank" :href="attachmentInfo.link">{{shortLink}}</a>
      </figcaption>
    </figure>
  </div>

  <div v-else-if="attachmentInfo && attachmentInfo.type=='campaign'" class="preview-img">
    <figure v-if="campaignInfo">
      <span v-on:click.prevent="$emit('remove-attachment')" class="remove"></span>
      <img v-if="campaignInfo.image" :src="campaignInfo.image" :alt="campaignInfo.name">
      <figcaption class="img-caption">
        <p>{{campaignInfo.name}}</p>
        <a target="_blank" :href="attachmentInfo.link">{{shortLink}}</a>
      </figcaption>
    </figure>
  </div>

  <div v-else-if="attachmentInfo && attachmentInfo.type=='none'" class="none-attachment">None</div>

  <div v-else></div>
</template>

<script>
  import attachmentsMixin from './attachments-mixin';

  export default {
    name: 'Attachment',
    mixins: [attachmentsMixin],
  };
</script>
